// src/redux/rootSaga.js

import { all } from 'redux-saga/effects'
import userSaga from './user/userSaga'
import listingsSaga from './listings/listingsSaga'
import bookingSaga from './booking/bookingSaga'
import pointsSaga from './points/pointsSaga'
import youtubeSaga from './youtube/youtubeSaga'
import userRulesSaga from './userRules/userRulesSaga'
import viewerRequestSaga from './viewerRequest/viewerRequestSaga'
import tenantSaga from './tenant/tenantSaga'
import ambassadorSaga from './ambassador/ambassadorSaga'
import paymentsSaga from './payments/paymentsSaga'
import favoritesSaga from './favorites/favoritesSaga'
import reviewsSaga from './reviews/reviewsSaga'
import statsSaga from './stats/statsSaga'

export default function* rootSaga() {
  yield all([
    userSaga(),
    listingsSaga(),
    bookingSaga(),
    pointsSaga(),
    youtubeSaga(),
    userRulesSaga(),
    viewerRequestSaga(),
    tenantSaga(),
    ambassadorSaga(),
    paymentsSaga(),
    favoritesSaga(),
    reviewsSaga(),
    statsSaga(),
  ])
}